const STORAGE_KEY = 'p2pInviteToken'
const QUERY_PARAM = 'invite'

// Session storage, not memory: the token has to outlive the round trip to MiCredentials,
// MiDataHub, Google or Microsoft, which reloads the app.
export function captureInviteToken (search: string): boolean {
  const token = new URLSearchParams(search).get(QUERY_PARAM)
  if (token == null || token.trim() === '') return false
  try {
    sessionStorage.setItem(STORAGE_KEY, token.trim())
  } catch {
    return false
  }
  return true
}

export function getInviteToken (): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearInviteToken (): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Storage is blocked (private mode, disabled site data), so there was nothing stored to clear.
  }
}
